// extracted by mini-css-extract-plugin
module.exports = {"list":"FlagList-module--list--2pKLs"};